import React, { useState } from "react";
import Logout from '../auth/Logout';
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

const ProfileDropdown = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className="dropdown profile-dropdown">
      <button
        className="notification-btn dropdown-toggle p-0"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          src={user?.image_url ? user?.image_url : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
          alt=""
        />
      </button>
      <div className="dropdown-menu dropdown-menu-end">
        <div className="d-flex align-items-center p-3 border-bottom gap-2 profile-drop-top">
          <img
            src={user?.image_url ? user?.image_url : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
            alt="User"
          />
          <Link
            to='/dashboard'
            className='header-menu'
            state={{ activeTab: 'profile' }}
          >
            <h3 className="mb-0 text-13 font-400 text">{user?.full_name}</h3>
          </Link>
        </div>
        <ul className="list-unstyled mb-0 p-2 profile-down-list">
          <li className="dropdown-item d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
            <span><svg
              width={21}
              height={21}
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4871 13.4287C7.10289 13.4287 4.21289 13.9404 4.21289 15.9895C4.21289 18.0387 7.08456 18.5687 10.4871 18.5687C13.8712 18.5687 16.7604 18.0562 16.7604 16.0079C16.7604 13.9595 13.8896 13.4287 10.4871 13.4287Z"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4865 10.5054C12.7074 10.5054 14.5074 8.70456 14.5074 6.48372C14.5074 4.26289 12.7074 2.46289 10.4865 2.46289C8.2657 2.46289 6.46487 4.26289 6.46487 6.48372C6.45737 8.69706 8.2457 10.4979 10.4582 10.5054H10.4865Z"
                stroke="#fff"
                strokeWidth="1.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </span> My Account
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li className="dropdown-item d-flex align-items-center gap-2 " style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
            <span><svg
              width={22}
              height={22}
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4946 11.0199H3.45703"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.8105 8.34717L14.4945 11.0202L11.8105 13.6932"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.79492 6.77327V5.91802C7.79492 4.0526 9.30651 2.54102 11.1728 2.54102H15.6498C17.5107 2.54102 19.0186 4.04893 19.0186 5.90977V16.1214C19.0186 17.9868 17.5061 19.4993 15.6407 19.4993H11.1628C9.30284 19.4993 7.79492 17.9905 7.79492 16.1306V15.2671"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </span> Logout
          </li>
        </ul>
      </div>
      <Logout
        open={open}
        handleClose={handleClose}
      />
    </div>
  );
};

export default ProfileDropdown;
